import ErrorBoundary from './ErrorBoundary';
import './ErrorBoundary.scss';

export default ErrorBoundary;
